import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-coupon-slider-1',
  templateUrl: './coupon-slider-1.component.html',
  styleUrls: ['./coupon-slider-1.component.css']
})
export class CouponSlider1Component implements OnInit {
  @Input() coupon: any;
  @Input() productCoupon: any;
  @Input() typeCode: number;
  @Input() isProductCoupon: boolean;

  @Output() couponSettingsChanged = new EventEmitter<any>();

  changeCouponSettings() {
    this.couponSettingsChanged.emit(this.typeCode);
  }

  constructor() { }

  ngOnChanges() {
    if (this.isProductCoupon && !this.productCoupon.offerta) {
      this.productCoupon.offerta = this.coupon.offerta;
    }
  }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/views/campaign/new-campaign/step-4/coupons/coupons-sliders/coupon-slider-1/coupon-slider-1.component.ts